<template>
  <div>
    <memberSkeketon :loading="skeletonLoading">
      <van-pull-refresh
        v-if="!showNet"
        v-model="isLoading"
        @refresh="onRefresh"
        class="index_wrap"
      >
        <div class="tips" v-if="isFirstEntry">
          <span>添加【积惠多】到“我的小程序”，随时购买特惠商品</span>
          <img src="@/assets/images/point.png" />
        </div>
        <search-item></search-item>
        <div class="top_wrap" :style="{ background: homeBackground }">
          <van-swipe
            :autoplay="3000"
            v-if="topImgs.length"
            class="bannerSwipe"
            indicator-color="#fff"
          >
            <van-swipe-item
              v-for="(image, index) in topImgs"
              :key="index"
              @click="swipclick(image, index, 'top')"
            >
              <van-image
                :src="image.imageUrl + '?x-oss-process=style/750w-2'"
                width="100%"
                height="3.52rem"
                lazy-load
                fit="cover"
              >
                <template v-slot:loading>
                  <div class="indexloadingbg"></div>
                </template>
              </van-image>
            </van-swipe-item>
          </van-swipe>
          <!-- banner底部menu列表 -->
          <div class="box_wrap back-white">
            <van-grid :column-num="4" :border="false">
              <van-grid-item v-for="item in menuList" :key="item.type" :text="item.title" @click="goNextPage(item.type)" >
                <img slot="icon" class="img-i" :src="require('@/assets/images/'+item.icon)" fit="contain"  />
              </van-grid-item>
            </van-grid>
          </div>
          <!-- banner底部menu列表 -->
          <div class="box_wrap" v-if="middleImgs.length">
            <van-swipe
              :autoplay="3000"
              class="twoBanner"
              indicator-color="#fff"
              :show-indicators="bottomImgs.length > 1"
            >
              <van-swipe-item
                v-for="(image, index) in middleImgs"
                :key="index"
                @click="swipclick(image, index, 'middle')"
              >
                <van-image
                  :src="image.imageUrl + '?x-oss-process=style/750w-2'"
                  width="100%"
                  height="2.3467rem"
                  lazy-load
                  fit="cover"
                >
                  <template v-slot:loading>
                    <div class="indexloadingbg"></div>
                  </template>
                </van-image>
              </van-swipe-item>
            </van-swipe>
          </div>

          <div
            class="activity box_wrap"
            v-if="specialList.length || buyslow.length"
          >
            <div class="act_tit">
              <div class="act_tit_l">
                <p class="act_tit_tit">
                  <span class="boldFont limitPrice">限时特价</span>
                  <i>{{ countDownHours }}</i
                  ><img src="@/assets/images/home_maohao.png" /><i>{{
                    countDownMinutes
                  }}</i
                  ><img src="@/assets/images/home_maohao.png" /><i>{{
                    countDownSeconds
                  }}</i>
                </p>
                <ul class="actt_con">
                  <li
                    v-for="item in specialList"
                    :key="item.itemId"
                    @click="gotoDetail(item)"
                  >
                    <!-- <van-image :src="item.skuMainImage" lazy-load fit="cover"></van-image> -->
                    <img
                      :src="item.mainImage + '?x-oss-process=style/750w-2'"
                      class="actt_img"
                      alt=""
                    />
                    <!-- <span class="nowPrice">￥<i>199</i>.98</span> -->
                    <!-- <p>{{item.skuMainImage}}</p> -->
                    <gprice
                      :price="item.salePrice"
                      color="#FA4949"
                      fsize="9px"
                      isize="11px"
                      class="nowPrice"
                      :splitPrice="true"
                    ></gprice>

                    <span class="orgPrice">{{
                      item.marketPrice | formatMoney()
                    }}</span>
                  </li>
                </ul>
              </div>
              <div class="act_tit_r" v-if="buyslow">
                <span class="boldFont">边买边省</span>
                <span class="bianmai"></span>
                <div>
                  <van-image
                    v-for="bs in buyslow"
                    class="actr_img"
                    :key="bs.itemId"
                    @click="gotoDetail(bs)"
                    :src="bs.mainImage + '?x-oss-process=style/750w-2'"
                    lazy-load
                    fit="cover"
                  >
                    <template v-slot:loading>
                      <div></div>
                    </template>
                  </van-image>
                </div>
              </div>
            </div>

            <div class="now_star" v-if="todayStar.length">
              <p>
                <span class="boldFont limitPrice">今日主推</span>
                <span class="star_ico sprice"></span>
              </p>
              <p class="jingxuan">
                <span class="boldFont limitPrice">精选好货</span>
                <span class="star_ico quality"></span>
              </p>
            </div>
            <ul class="star_list" v-if="todayStar.length">
              <li
                v-for="item in todayStar"
                :key="item.goodsId"
                @click="gotoDetail(item)"
              >
                <img
                  :src="item.mainImage + '?x-oss-process=style/750w-2'"
                  alt=""
                />
              </li>
            </ul>
          </div>
          <!-- 新人专享 -->
          <div
            class="activity box_wrap"
            v-if="(isNewer || !isLogin) && newUserList.length"
          >
            <div class="act_tit">
              <div class="act_tit_r flex-1">
                <div>
                  <van-cell
                    center
                    value="更多"
                    is-link
                    style="padding: 0"
                    :clickable="false"
                    @click="goNewList"
                  >
                    <!-- 使用 title 插槽来自定义标题 -->
                    <template #title>
                      <span class="custom-title">新人专享</span>
                      <!-- <van-tag type="danger"></van-tag> -->
                    </template>
                  </van-cell>
                </div>
                <ul
                  class="actt_con"
                  :style="{
                    justifyContent:
                      newUserList && newUserList.length > 2
                        ? 'space-between'
                        : 'flex-start',
                  }"
                >
                  <li
                    style="margin-right: 10px"
                    v-for="item in newUserList"
                    :key="item.itemId"
                    @click="gotoDetail(item)"
                  >
                    <!-- <van-image :src="item.skuMainImage" lazy-load fit="cover"></van-image> -->
                    <img
                      :src="item.mainImage + '?x-oss-process=style/750w-2'"
                      class="actt_img"
                      style="width: 2.56rem; height: 2.56rem"
                      alt=""
                    />
                    <!-- <span class="nowPrice">￥<i>199</i>.98</span> -->
                    <!-- <p>{{item.skuMainImage}}</p> -->
                    <gprice
                      :price="item.salePrice"
                      color="#FA4949"
                      fsize="9px"
                      isize="11px"
                      class="nowPrice"
                      :splitPrice="true"
                    ></gprice>

                    <!-- <span class="orgPrice">{{
                      item.marketPrice | formatMoney()
                    }}</span> -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <todayMustp :todaymp="homeCollage" v-if="homeCollage.length" />

          <ul class="promat_list" v-if="actGoodsList.length">
            <li v-if="actGoodsList[0]" @click="gotoDetail(actGoodsList[0])">
              <img
                :src="actGoodsList[0].mainImage + '?x-oss-process=style/750w-2'"
                alt=""
              /><span class="mustbuy">必买清单</span>
            </li>
            <li v-if="actGoodsList[1]" @click="gotoDetail(actGoodsList[1])">
              <img
                :src="actGoodsList[1].mainImage + '?x-oss-process=style/750w-2'"
                alt=""
              /><span class="morepromat">优惠多多</span>
            </li>
            <li v-if="actGoodsList[2]" @click="gotoDetail(actGoodsList[2])">
              <img
                :src="actGoodsList[2].mainImage + '?x-oss-process=style/750w-2'"
                alt=""
              /><span class="crizyBuy">疯抢不停</span>
            </li>
            <li v-if="actGoodsList[3]" @click="gotoDetail(actGoodsList[3])">
              <img
                :src="actGoodsList[3].mainImage + '?x-oss-process=style/750w-2'"
                alt=""
              /><span class="lowprice">击破底价</span>
            </li>
          </ul>
        </div>

        <div class="con_wrap">
          <div class="box_wrap" v-if="bottomImgs.length">
            <van-swipe
              :autoplay="3000"
              class="twoBanner"
              indicator-color="#fff"
              :show-indicators="bottomImgs.length > 1"
            >
              <van-swipe-item
                v-for="(image, index) in bottomImgs"
                :key="index"
                @click="swipclick(image, index, 'bottom')"
              >
                <van-image
                  :src="image.imageUrl + '?x-oss-process=style/750w-2'"
                  lazy-load
                  fit="cover"
                >
                  <template v-slot:loading>
                    <div class="indexloadingbg"></div>
                  </template>
                </van-image>
              </van-swipe-item>
            </van-swipe>
          </div>

          <van-list
            v-model="skulistLoading"
            @load="getGoodsList"
            :finished="currentPage >= totalPage"
          >
            <div class="goodsList" id="goodsList">
              <div class="column">
                <goodsItem
                  v-for="(item,index) in leftList"
                  :key="item.goodsId"
                  :goods="item"
                  c-type="feed"
                  :f-index="'left-'+index"
                ></goodsItem>
              </div>
              <div class="column">
                <goodsItem
                  v-for="(item,index) in rightList"
                  :key="item.goodsId"
                  :goods="item"
                  :f-index="'right-'+index"
                  c-type="feed"
                ></goodsItem>
              </div>
            </div>
          </van-list>
        </div>

        <div class="skuloading">
          <van-loading v-if="skulistLoading" color="#F84F24" size="24px" />
        </div>

        <div class="bottomlogo" v-if="currentPage >= totalPage">
          <div>
            <p>京B2-20192560 | 京ICP18028417号-1</p>
            <p>Copyright © 2019 jihuiduo.cn</p>
          </div>
          <p>客服电话 : 400-101-5288</p>
        </div>
        <!-- 去掉领积分悬浮 -->
        <!-- <div
          class="modal-box"
          @click="showPromotion"
          v-if="!infoCompletedFlag"
        ></div> -->
      </van-pull-refresh>

      <noNet v-if="showNet" @reConnect="reConnect"></noNet>
    </memberSkeketon>

    <foot></foot>

    <van-dialog class="jifenpop" v-model="showjifen" :showConfirmButton="false">
      <integralPop @closePop="closePop"></integralPop>
    </van-dialog>

    <van-dialog
      v-model="showprivacy"
      class="privacywrap"
      :showConfirmButton="false"
    >
      <privacypop></privacypop>
      <span class="privacybtn" @click="closePrivacy">已阅读并同意</span>
    </van-dialog>

    <img src="@/assets/images/shopcar_net.png" class="disimg" />
  </div>
</template>
<script>
import "@/assets/icons/order.svg";
import "@/assets/icons/tuiguang.svg";
import "@/assets/icons/score.svg";
import "@/assets/icons/memberMsg.svg";
import "@/assets/icons/service.svg";
import foot from "@/components/foot";
import noNet from "@/components/noNet";
import privacypop from "./privacy";
import integralPop from "./integralPop";
import { api } from "@/config/configUrl";
import { mapState, mapGetters, mapActions } from "vuex";
import goodsItem from "@/components/goodsItem";
import todayMustp from "./todayMustp";
import gprice from "@/components/gprice";
import memberSkeketon from "./memberSkeketon";
import SearchItem from '@/components/searchItem'
let baseGameURL = process.env.VUE_APP_H5_HOST;
const privacy = "0.0.2";

let intervals = null;
const menuList = [{
  title:'商城订单',
  icon:'order2.png',
  type:'orderList'
},{
  title:'我的推广',
  icon:'tuiguang.png',
  type:'myPromotionCode'
},{
  title:'我的积分',
  icon:'score2.png',
  type:'pointList'
},{
  title:'会员信息',
  icon:'member2.png',
  type:'memberDetail'
},{
  title:'客服热线',
  icon:'service2.png',
  type:'customerService'
},{
  title:'领劵',
  icon:'icon-coupon.png',
  type:'couponList'
},{
  title:'签到任务',
  icon:'signIn.png',
  type:'signIn'
},{
  title:'助力活动',
  icon:'help.png',
  type:'help'
}]
export default {
  name: "",
  components: {
    goodsItem,
    gprice,
    foot,
    integralPop,
    memberSkeketon,
    noNet,
    privacypop,
    todayMustp,
    SearchItem
  },
  data() {
    return {
      isLoading: false,
      countDownDays: 0,
      countDownHours: 0,
      countDownMinutes: 0,
      countDownSeconds: 0,
      // skeletonLoading: true,
      showjifen: false,
      infoCompletedFlag: true,
      pageSize: 10,
      skulist: [],
      currentPage: 1,
      skulistLoading: false,
      isFinish: false,
      initLoad: true,
      showNet: false,
      isFirstEntry: true,
      showprivacy: false,
      isNewUser: false,
      menuList:menuList
    };
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      bannerList: (state) => state.member.bannerList,
      topImgs: (state) => state.member.topImgs,
      middleImgs: (state) => state.member.middleImgs,
      bottomImgs: (state) => state.member.bottomImgs,
      homeBackground: (state) => state.member.homeBackground,
      goodsList: (state) => state.member.goodsList,
      goodsDuration: (state) => state.member.goodsDuration,
      homeCollage: (state) => state.member.homeCollage,
      skeletonLoading: (state) => state.member.skeletonLoading,
      isNewer: (state) => state.user.isNewer,
    }),
    ...mapGetters({
      specialList: "specialList",
      buyslow: "buyslow",
      todayStar: "todayStar",
      actGoodsList: "actGoodsList",
      leftList: "leftList",
      rightList: "rightList",
      totalPage: "totalPage",
      newUserList: "newUserList",
    }),
  },
  async mounted() {
    let query = this.$route.query;
    // console.log(query,this.$route)
    await this.checkLogin();
    // console.log(this.isLogin)
    // this.$toast(this.isLogin?'true':'false')
    // 检查是否新人
    if (this.isLogin) this.checkNewer()
    if (query.scene) {
      let scene = decodeURIComponent(query.scene);
      if (scene.startsWith("&1=")) {
        let fmid = scene.split("=");
        localStorage.setItem(this.$env + "friendMemberId", fmid[1]);
        let friendstr = fmid ? "&friendMemberId=" + fmid : "";
        if (query.rt) {
          this.$wx.miniProgram.redirectTo({
            url:
              "/pages/webView/webView?pageUrl=" +
              baseGameURL +
              "/perishVirus/index.html&accessToken=" +
              query.at +
              "&memberId=" +
              query.memberId +
              friendstr,
          });
        } else {
          this.$wx.miniProgram.redirectTo({
            url:
              "/pages/login/login?pagefrom=/pages/webView/webView&pageUrl=" +
              baseGameURL +
              "/perishVirus/index.html", //+path+"&"+fullPath.split('?')[1]
          });
        }
      }
    }
    if (query.goodsId === "virus") {
      this.$store.dispatch("user/checkLogin").then((res) => {
        let friendMemberId = query.productId || "";
        if (friendMemberId) {
          localStorage.setItem(this.$env + "friendMemberId", friendMemberId);
        } else if (query.scene) {
        } else {
          localStorage.removeItem(this.$env + "friendMemberId");
        }
        let friendstr = friendMemberId
          ? "&friendMemberId=" + friendMemberId
          : "";

        if (query.rt) {
          this.$wx.miniProgram.redirectTo({
            url:
              "/pages/webView/webView?pageUrl=" +
              baseGameURL +
              "/perishVirus/index.html&accessToken=" +
              query.at +
              "&memberId=" +
              query.memberId +
              friendstr,
          });
        } else {
          this.$wx.miniProgram.redirectTo({
            url:
              "/pages/login/login?pagefrom=/pages/webView/webView&pageUrl=" +
              baseGameURL +
              "/perishVirus/index.html", //+path+"&"+fullPath.split('?')[1]
          });
        }
      });
      return;
    }
    if (this.$route.query.isFirstEntry) {
      this.isFirstEntry = true;
    } else {
      this.isFirstEntry = false;
    }

    // let page = this;
    // 设置防抖debounce
    // window.addEventListener("scroll", page.getPageList(this.scrollBottom, 100));
    this.init("load", () => {
      try {
        let loadTime = new Date().getTime() - this.initTime;
        this.$service.getStatisCommon("evn_open_page", { ltime: loadTime });
      } catch (e) {
        // alert(e)
      }
    });
    let localPrivacy = localStorage.getItem(this.$env + "localPrivacy");
    if (query.minit) {
      // 小程序
      if (query.rt) {
        localStorage.setItem(this.$env + "authToken", query.at);
        localStorage.setItem(this.$env + "refreshToken", query.rt);
        localStorage.setItem(this.$env + "memberId", query.memberId);
        if (privacy !== localPrivacy) {
          localStorage.setItem(this.$env + "localPrivacy", privacy);
          this.$logout();
        }
        this.getDegree();
      } else {
        localStorage.removeItem(this.$env + "authToken");
        localStorage.removeItem(this.$env + "refreshToken");
        // localStorage.removeItem(this.$env+"memberId")
      }
    } else {
      // 非小程序
    
      this.$store.dispatch("user/checkLogin").then((res) => {
        if (this.isLogin) {
          // this.requestUserInfo()
          this.getDegree();
        }
      });
      if (privacy !== localPrivacy && this.$platform !== "miniProgram") {
        this.popPrivacy();
        this.$store.dispatch("user/logout");
      }
    }

    let dtime = new Date().getTime() - this.initTime;
    this.$service.getStatisCommon("evn_dom_finish", { ltime: dtime, ed: {} });
  },
  destroyed() {
    let page = this;
    // window.removeEventListener("scroll", page.getPageList);
    this.intervals = null;
  },
  methods: {
    ...mapActions("user", ["checkNewer", "checkLogin"]),
    /**
     * @description 任务详情
     */
    taskDetail: function () {
      return new Promise(resolve=>{
        const param = {
          platformType: 1,
          state: 1, //状态: 1进行中 2未开始 3已结束
        };
        this.$service.task(param).then((res) => {
          resolve(res)
        });
      })
    },
    reConnect() {
      this.init();
    },
    popPrivacy() {
      this.showprivacy = true;
      document.documentElement.style.overflow = "hidden";
      document.body.style.height = "100vh";
      document.body.style.overflow = "hidden";
    },
    closePrivacy() {
      this.showprivacy = false;
      localStorage.setItem(this.$env + "localPrivacy", privacy);
      document.documentElement.style.overflow = "auto";
      document.body.style.height = "auto";
      this.$service.getStatisCommon("evn_confirm_privacy", {});
    },
    init(load, callback) {
      clearInterval(intervals);
      if(this.isLogin) this.checkNewer()
      this.$store.dispatch("member/getList", (e) => {
        if (e === "neterror") {
          this.showNet = true;
          return;
        }
        this.showNet = false;
        this.countDownTime(this.goodsDuration);
        this.isLoading = false;
        if (!load) {
          // this.$toast("刷新成功")
        }
        callback && callback();
        // console.log(this.newUserList)
      });

      this.currentPage = 1;
      this.getHomeSkuList();
    },
    async getDegree() {
      let memberId = localStorage.getItem(this.$env + "memberId");
      let params = memberId + "/degree";
      try {
        let res = await this.$service.getMemberV1(params);
        this.infoCompletedFlag = res.result === "100%";
        localStorage.setItem(this.$env + "infoCompletedFlag", res.result);
      } catch (e) {
        console.log(e);
      }
    },

    getHomeSkuList() {
      this.skulistLoading = true;
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$store.dispatch("member/getSkuList", {
        params: params,
        callback: () => {
          if (this.initLoad) {
            // this.skeletonLoading = false;
            this.initLoad = false;
          }
          this.skulistLoading = false;
        },
      });
    },

    async requestUserInfo() {
      let memberId = localStorage.getItem(this.$env + "memberId");
      try {
        let res = await this.$service.getMemberV1(memberId);
        if (res.status === 200) {
          this.memberName = res.result.memberName;
          this.cellPhone = res.result.cellPhone;
          localStorage.setItem(this.$env + "memberName", res.result.memberName);
          localStorage.setItem(this.$env + "cellPhone", res.result.cellPhone);
          localStorage.setItem(
            this.$env + "promotedCount",
            res.result.promotedCount
          );
          localStorage.setItem(this.$env + "promoterId", res.result.promoterId);
        }
      } catch (e) {}
    },

    // scrollBottom() {
    //   if (this.currentPage >= this.totalPage || this.skulistLoading) {
    //     return;
    //   }
    //   let scrollTop =
    //     document.documentElement.scrollTop || document.body.scrollTop;
    //   let clientHeight = document.documentElement.clientHeight;
    //   let scrollHeight = document.documentElement.scrollHeight;
    //   //  alert(scrollTop+"-"+clientHeight+"-"+scrollHeight)
    //   // console.log(scrollTop, clientHeight, scrollHeight);
    //   // 解决无法判断滚动触底问题,实际情况会遇到scrollTop+clientHeight 无限接近scrollHeight但并不会大于或等于
    //   if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
    //     this.currentPage++;
    //     this.getHomeSkuList();
    //   }
    // },
    getGoodsList() {
      if (this.currentPage >= this.totalPage) {
        return;
      }
      this.currentPage++;
      this.getHomeSkuList();
    },
    /**
     * @description 上拉加载获取下一页数据，设置防抖，防止性能损耗
     * @param {Function} fn 需要延时调用的方法
     * @param {Number} delay 延时时间 ms级
     *
     */
    // getPageList(fn, delay) {
    //   let timer = null;
    //   return function () {
    //     if (timer) clearTimeout(timer);

    //     timer = setTimeout(fn, delay);
    //   };
    // },
    countDownTime(tso) {
      let totalSecond = tso;
      if (totalSecond === "notime") {
        totalSecond = 0;
      }
      intervals = setInterval(() => {
        if (totalSecond == 0) {
          clearInterval(intervals);
          this.$store.dispatch("member/getList");
          return;
        }
        // 秒数
        var second = totalSecond;
        // 天数位
        var day = Math.floor(second / 3600 / 24);
        var dayStr = day.toString();
        if (dayStr.length === 1) {
          dayStr = "0" + dayStr;
        }
        // 小时位
        var hr = Math.floor((second - day * 3600 * 24) / 3600);
        var hrStr = hr.toString();
        if (hrStr.length === 1) {
          hrStr = "0" + hrStr;
        }
        // 分钟位
        var min = Math.floor((second - day * 3600 * 24 - hr * 3600) / 60);
        var minStr = min.toString();
        if (minStr.length === 1) {
          minStr = "0" + minStr;
        }
        // 秒位
        var sec = second - day * 3600 * 24 - hr * 3600 - min * 60;
        var secStr = sec.toString();
        if (secStr.length === 1) {
          secStr = "0" + secStr;
        }
        this.countDownDays = dayStr;
        this.countDownHours = hrStr || 0;
        this.countDownMinutes = minStr || 0;
        this.countDownSeconds = secStr || 0;

        totalSecond--;
      }, 1000);
    },

    gotoDetail: function (item) {
      let params = {
        saleSkuId: item.itemId,
      };
      this.$navigateTo("detail", params);
    },
    getDistance(data) {
      let page = this;

      if (data) {
        localStorage.setItem(
          this.$env + "currentLocation_Latitude",
          data.latitude
        );
        localStorage.setItem(
          this.$env + "currentLocation_Longitude",
          data.longitude
        );

        let location = `${data.latitude},${data.longitude}`;

        let res = this.$jsonp(api.txMap, {
          location: location,
          key: "UAYBZ-2R6WF-DYUJR-NY36V-DTIKK-ZUBYQ",
          output: "jsonp",
        })
          .then((res) => {
            let toAddressStr = res.result.address;
            let addrcom = res.result.address_component;
            let locations = {
              toAddress: toAddressStr,
              addrprovince: addrcom.province,
              addrcity: addrcom.city,
              area: addrcom.district,
              address: addrcom.street,
            };
            page.setUserLocation(locations);
          })
          .catch((e) => {
            let locations = {
              toAddress: "",
              addrprovince: "北京市",
              addrcity: "市辖区",
              area: "朝阳区",
              address: "",
            };
            page.setUserLocation(locations);
          });
        return;
      } else {
        // wx.hideLoading()
      }
    },

    setUserLocation(locations) {
      let addrStr = JSON.stringify(locations);
      localStorage.setItem(this.$env + "userLocation", addrStr);
    },
    onRefresh() {
      this.isLoading = true;
      this.init();
    },
    swipclick(itemData, idx, position) {
      let event = position == 'bottom' ? 'event_basal_banner_click' : `event_${position}_banner_click`
      const ml = {
        top:74,
        middle:75,
        bottom:76
      }
      this.sendStatics(event,{currentUrl:1,module:ml[position],bannerSite:idx,url:itemData.pageUrl})
      if (itemData.pageUrl === "game") {
        this.$service.getStatisCommon("evn_banner_click", {
          ed: {
            index: idx,
            pageUrl: itemData.pageUrl,
            imageUrl: itemData.imageUrl,
            position: position,
            curl: "/",
          },
        });
        this.$store.dispatch("user/checkLogin").then((res) => {
          if (this.isLogin) {
            let query = this.$route.query;
            this.$wx.miniProgram.navigateTo({
              url:
                "/pages/webView/webView?pageUrl=" +
                baseGameURL +
                "/perishVirus/index.html?accessToken=" +
                query.at +
                "memberId=" +
                query.memberId,
            });
          } else {
            this.$wx.miniProgram.redirectTo({
              url:
                "/pages/login/login?pagefrom=/pages/webView/webView&pageUrl=" +
                baseGameURL +
                "/perishVirus/index.html", //+path+"&"+fullPath.split('?')[1]
            });
          }
        });
        return;
      }

      if (itemData.pageUrl) {
        this.$service.getStatisCommon("evn_banner_click", {
          ed: {
            index: idx,
            pageUrl: itemData.pageUrl,
            imageUrl: itemData.imageUrl,
            position: position,
            curl: "/",
          },
        });
        if (this.$platform === "miniProgram") {
          this.$navigateTo("outerPage", { pageUrl: itemData.pageUrl });
        } else {
          this.$navigateTo("outerPage", {
            pageUrl: itemData.pageUrl,
            isweb: "isweb",
          });
        }
      }
    },

    async goNextPage(name) {
      const obj = {
        myPromotionCode:{
          e:'event_my_promotion_click',
          m:88
        },
        pointList:{
          e:'event_my_integration_click',
          m:89
        },
        customerService:{
          e:'event_service_click',
          m:91
        },
        couponList:{
          e:'event_ticket_center_click',
          m:92
        },
        signIn:{
          e:'event_sign_in',
          m:17
        }
      }
      if(obj[name]){
        this.sendStatics(obj[name].e,{currentUrl:1,module:obj[name].m})
      }
      if(name == 'signIn' && this.isLogin){
        const res = await this.taskDetail()
        if(res.result <= 0 ) {
          this.$toast('活动暂未开始')
          return
        }
      }
      this.$navigateTo(name, { urlstr: name });
    },
    showPromotion() {
      this.showjifen = true;
    },
    closePop() {
      this.showjifen = false;
    },
    goNewList: function () {
      console.log("goNew");
      // this.$navigateTo('productList')
      // this.$router.push({ path: '/newerList', query: {}})
      this.$navigateTo("newerList", { urlstr: "newerList" });
    },
  },
};
</script>
<style scoped lang='less' src="@/style/home.less"></style>
